export default __webpack_public_path__ + "static/media/fireFN19.314ae1dc.svg";